export default __webpack_public_path__ + "static/psle-logo-c7421686a0a6a29a160a4092081a3976.png";